import type { MouseEvent } from "react";
import type { DropzoneState } from "react-dropzone";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { CircularProgress } from "@circle-react-shared/uikit/TipTap/AttachmentPreviews/CircularProgress";
import { Typography } from "@circle-react-shared/uikit/Typography";

export interface UploadMediaButtonProps {
  ariaLabel?: string;
  getRootProps?: () => DropzoneState;
  isUploading: boolean;
  onSelectFile: (event: MouseEvent<HTMLButtonElement>) => void;
  progress?: number;
  uploadingText?: string;
}

export const UploadMediaButton = ({
  progress = 0,
  isUploading,
  ariaLabel = t("builder_ui.prop_type.attachment_upload.add_file"),
  uploadingText = t("builder_ui.prop_type.attachment_upload.uploading_file"),
  onSelectFile,
  getRootProps,
}: UploadMediaButtonProps) => (
  <div {...getRootProps?.()}>
    <button
      type="button"
      disabled={isUploading}
      className="border-dark bg-secondary focus:!outline-secondary flex h-32 w-full items-center justify-center rounded-lg border border-dashed px-6 py-3 focus:!outline-1 focus:!outline-offset-0"
      onClick={onSelectFile}
    >
      <div className="flex flex-col items-center justify-center gap-2">
        {isUploading ? (
          <span
            className={classNames("flex size-7 items-center justify-center", {
              "animate-spin-fast": progress === 0,
            })}
          >
            <CircularProgress
              percentage={progress === 0 ? 100 : progress}
              size={28}
              strokeWidth={3}
            />
          </span>
        ) : (
          <span className="flex size-7 items-center justify-center rounded-full bg-black">
            <Icon
              type="20-plus-v3"
              size={20}
              className="text-white"
              aria-label={ariaLabel}
            />
          </span>
        )}
        <Typography.LabelXs weight="semibold">
          {isUploading ? uploadingText : ariaLabel}
        </Typography.LabelXs>
      </div>
    </button>
  </div>
);
